export default __webpack_public_path__ + "static/media/arrow-icon-white.b1e0a811.svg";